import $ from 'jquery';
import React from 'react';

interface IProps {
  children: React.ReactElement;
  title: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

class Tooltip extends React.Component<IProps> {
  static defaultProps = {
    position: 'top',
  };

  // Replaces ReactDOM.findDOMNode, which is deprecated in React 18 and removed
  // in 19. The ref is attached to the cloned child below, which is the element
  // findDOMNode used to resolve to. This means the child has to be a host
  // element (or forward its ref) — as it was already, since the component
  // spreads data-* attributes onto it.
  private childRef = React.createRef<HTMLElement>();

  componentDidMount() {
    $(this.childRef.current).tooltip();
  }

  render() {
    const { children, position, title } = this.props;
    const childrenProps = children.props;

    const tooltipAttributes = {
      'data-toggle': 'tooltip',
      'data-placement': position,
      'data-original-title': title,
    };

    return React.cloneElement(this.props.children, { ...childrenProps, ...tooltipAttributes, ref: this.childRef });
  }
}

export default Tooltip;
